<template>
  <aside class="sidebar">

    <!-- Sidebar panel -->
    <side-category-panel v-if="getCurrentSlug && !getSkuParam"
                         :is-categories-loaded="isCategoriesLoaded"
                         :categories="tree"
    />
    <!---->

  </aside>
</template>

<script>
import SideCategoryPanel from 'theme/components/core/blocks/Shop/Sidebar/SideCategoryPanel'
import {mapActions, mapGetters} from 'vuex'

export default {
  components: {
    SideCategoryPanel
  },
  data () {
    return {
      isCategoriesLoaded: false
    }
  },
  mounted () {
    this.getTree({ partner_code: this.currentPartner.code, location_code: this.currentPartner.location_code })
      .finally(() => this.isCategoriesLoaded = true)
  },
  watch: {
    '$route.params.store': {
      handler: function () {
        this.isCategoriesLoaded = false
        this.getTree({ partner_code: this.currentPartner.code, location_code: this.currentPartner.location_code })
          .finally(() => this.isCategoriesLoaded = true)
      }
    }
  },
  computed: {
    ...mapGetters({
      currentPartner: 'partners/getCurrentPartner',
      getPartnerCategoryTree: 'category/getPartnerCategoryTree'
    }),
    getCurrentSlug () {
      return this.$route.params.slug
    },
    getSkuParam () {
      return this.$route.params.childSku
    },
    tree () {
      return this.getPartnerCategoryTree(`${this.currentPartner.location_code}_${this.currentPartner.code}`)
    }
  },
  methods: {
    ...mapActions({
      getTree: 'category/getPartnerCategoryTree'
    })
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  width: 262px;

  @media only screen and (max-width: 991px) {
    display: none
  }
}
</style>
